import React, {useState, useRef} from 'react'
import {CloseButton} from "../buttons"
import {LinkIcon} from "../item-types"
import {DataLinkDialog} from './DataLinkDialog'
import {DataLink} from '@dv5/domain'
import './DataLinkOverview.less'

interface DataLinkOverviewProps {
    dataLinkCount: number
    sourceItemId: string
    onNavigate: (dataLink: DataLink) => void
    onShowDialog: (show: boolean) => void
    onDelete: (dataLink: DataLink, sourceItemId: string) => void
}

export const DataLinkOverview: React.FC<DataLinkOverviewProps> = ({
                                                                      dataLinkCount,
                                                                      sourceItemId,
                                                                      onNavigate,
                                                                      onShowDialog,
                                                                      onDelete,
                                                                  }) => {
    const [showDialog, setShowDialog] = useState(false)
    const iconRef = useRef<HTMLDivElement>(null)
    const dialogRef = useRef<HTMLDivElement>(null)

    const dialogControl = (newValue: boolean) => {
        setShowDialog(newValue)
        onShowDialog(newValue)
    }
    const handleDelete = (dataLink: DataLink) => {
        onDelete(dataLink, sourceItemId)
        setShowDialog(false)
    }

    if (dataLinkCount <= 0) {
        return null
    }

    const handleClick = () => {
        dialogControl(true)
    }

    const handleClose = () => {
        dialogControl(false)
    }

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (dialogRef.current && !dialogRef.current.contains(e.target as Node)) {
            handleClose()
        }
    }

    return (
        <>
            <div
                ref={iconRef}
                className="data-link-overview"
                title={`${dataLinkCount} link${dataLinkCount !== 1 ? 's' : ''}`}
                onClick={handleClick}
            >
                <LinkIcon className="data-link-overview-icon"/>
            </div>
            {showDialog && (
                <div className="data-link-dialog-overlay" onClick={handleOverlayClick}>
                    <div className="data-link-dialog" ref={dialogRef}>
                        <CloseButton onClose={handleClose} className="data-link-dialog-close"/>
                        <DataLinkDialog sourceItemId={sourceItemId}
                                        dataLinkCount={dataLinkCount}
                                        onNavigate={onNavigate}
                                        onDelete={handleDelete}
                                        quickCreation={false}
                        />
                    </div>
                </div>
            )}
        </>
    )
}
